module.exports = permissions;